import React from "react";
import { Typography } from "@material-ui/core";
import { useFormContext } from "react-hook-form";
import { OperatingManagerFormFields } from "Shared/types/OperatingManager";
import {
  PersonalDetailsFormTextFields
} from "Components/Shared/FormComponents/PersonalDetailsFormTextFields/PersonalDetailsFormTextFields";

export interface OperatingManagerDetailsProps {
  formFields: OperatingManagerFormFields;
  shouldDisableFields: boolean;
}

export const OperatingManagerDetails = ({
  formFields,
  shouldDisableFields
}: OperatingManagerDetailsProps) => {
  const { register, errors } = useFormContext<OperatingManagerFormFields>();

  return (
    <>
      <Typography variant="h3">
        Operating Manager Information
      </Typography>
      <PersonalDetailsFormTextFields
        errors={errors}
        register={register}
        additionalTextFieldProps={{
          firstName: {
            defaultValue: formFields.firstName,
            disabled: shouldDisableFields,
          },
          lastName: {
            defaultValue: formFields.lastName,
            disabled: shouldDisableFields,
          },
          email: {
            defaultValue: formFields.email,
            disabled: true,
          },
          phoneNumber: {
            defaultValue: formFields.phoneNumber,
            disabled: shouldDisableFields,
          },
        }}
      />
    </>
  );
};
